export const checkIsReelPost = (postUrl?: string | null) => !!postUrl && postUrl?.includes('/reel/');
